module.exports = __webpack_public_path__ + "img/no-alcohol.a58f947e.svg";